import { Grid } from "@mui/material"
import UserContextP from "Interfaces/Context"
import { useContext } from "react"

interface PropsInterface {
    order:any
    costumer:any
    color:string
}

const Header = ( props: PropsInterface ) => {
    const { order, costumer } = props
    const context = useContext(UserContextP)
    return (
        <>
            <Grid item xs={6} sx={{ border: "1px solid #000" }}>
                <div className="thBase thHeader">
                    <p>
                        Razón social
                    </p>
                </div>
            </Grid>
            {/* Nombre Comercial */}
            <Grid item xs={6}  sx={{ border: "1px solid #000" }}>
                <div className="thBase thHeader">
                    <p>
                        Nombre Comercial
                    </p>
                </div>
            </Grid>
            <Grid item xs={6} sx={{ border: "1px solid #000" }}>
                <div className="thBase thContent">
                    <h4>
                        {costumer?.CardName}
                    </h4>
                </div>
            </Grid>
            <Grid item xs={6}  sx={{ border: "1px solid #000" }}>
                <div className="thBase thContent">
                    <h4>
                        {costumer?.CardFName}
                    </h4>
                </div>
            </Grid>

            <Grid item xs={6} sx={{ border: "1px solid #000" }}>
                <div className="thBase thContent">
                    <h4>
                        Saldo pendiente
                    </h4>
                </div>
            </Grid>

            <Grid item xs={6} sx={{ border: "1px solid #000" }}>
                <div className="thBase thContent">
                    <p>
                        $ {context.separatorMiles(costumer?.Balance ?? 0)}
                    </p>
                </div>
            </Grid>



            <Grid item xs={6} sx={{ border: "1px solid #000" }}>
                <div className="thBase thContent">
                    <h4>
                        Limite de credito
                    </h4>
                </div>
            </Grid>

            <Grid item xs={6} sx={{ border: "1px solid #000" }}>
                <div className="thBase thContent">
                    <p>
                        $ {context.separatorMiles(costumer?.CreditLine ?? 0)}
                    </p>
                </div>
            </Grid>

            <Grid item xs={12}  sx={{ border: "1px solid #000" }}>
                <div className="thBase thContent">
                    <h4>
                        {order?.street !== '' ? order?.street : 'No posee dirección'}
                    </h4>
                </div>
            </Grid>
        </>
    )
}

export default Header